let headerStyle = {
    display: "flex",
    justifyContent: "space-around",
    postion: "fixed",
    top: 0,
    width: "100%",
    background: "white",
};
export default headerStyle;
